export default __webpack_public_path__ + "static/media/DoD-Icon-Dark-Simple.ef545ecf.png";